export default "__VITE_ASSET__Dq9WZiG5__"